import { Box, Snackbar, styled } from "@mui/material";

export const SnackBarWrapper = styled(Snackbar) <any>`
  -webkit-backdrop-filter: blur(17px);
  backdrop-filter: blur(0.5rem);
  background-color: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  top: 0 !important;
`;

export const AlertWrapper = styled(Box)(({ theme }) => ({
  "&& .MuiPaper-root": {
    borderRadius: "12px",
    background: "none",
    boxSizing: "border-box",
    paddingTop: "3rem",
    width: "100%",
    margin: "auto",
    position: "relatiive",
    zIndex: 10000,
  },
  ".toaster-message": {
    fontWeight: 300,
    fontSize: "2rem",
    color: "var(--white-color)",
    lineHeight: "1.67",
  },
  ".toaster-message.success": {
    color: "var(--primary-success-color)",
  },
  ".toaster-message.error": {
    color: "var(--primary-error-color)",
  },
  "&& .snackbar-icon": {
    width: "3rem",
    height: "3rem",
    objectFit: "contain",
    fontFamily: "Comfortaa-Light",
  },
  "&& .alert-style": {
    display: "flex",
    alignItems: "center",
    width: "fit-content",
  },

  "@media screen and (max-width:840px)": {
    ".toaster-message": {
      fontSize: "1.4rem",
    },
  },
}));
